import LoaderLabel from './LoaderLabel';

export default LoaderLabel;